function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#889ccc}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_203",
  "data-name": "Path 203",
  className: "cls-2",
  d: "m10.939 5-.409 6.734a.531.531 0 0 1-1.061 0L9.061 5a.941.941 0 1 1 1.879 0z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_204",
  "data-name": "Path 204",
  className: "cls-2",
  d: "M9 15a1 1 0 1 1 1 1 1 1 0 0 1-1-1z"
});

var SvgAlert = function SvgAlert(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_63",
    "data-name": "Group 63",
    width: 20.009,
    height: 18.995,
    viewBox: "0 0 20.009 18.995",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M9.551.006 9.22.065a4.95 4.95 0 0 0-1.014.324 4.539 4.539 0 0 0-1.6 1.411C6.384 2.135.52 12.814.371 13.155a4.159 4.159 0 0 0 2.789 5.754l.331.091h12.988l.332-.086a4.132 4.132 0 0 0 3.064-3.194 3.184 3.184 0 0 1 .1-.421 2.649 2.649 0 0 0 0-.843c-.019.012-.047-.088-.061-.221a4.537 4.537 0 0 0-.315-1.075c-.149-.341-6.012-11.02-6.234-11.355A4.1 4.1 0 0 0 10.824.078 6.054 6.054 0 0 0 9.556.007zm.026 1.2a2.941 2.941 0 0 0-2.115 1.442c-.306.519-5.875 10.7-6 10.974a2.576 2.576 0 0 0-.262 1.244 2.987 2.987 0 0 0 2.143 2.851l.309.091h12.675l.31-.091a2.987 2.987 0 0 0 2.143-2.851 2.588 2.588 0 0 0-.264-1.244c-.129-.276-5.7-10.455-6-10.974a2.956 2.956 0 0 0-1.764-1.365 3.358 3.358 0 0 0-1.167-.076zM.04 14.886c0 .239.017.332.037.206a1.578 1.578 0 0 0 0-.434c-.02-.113-.036-.01-.036.229",
    style: {
      fillRule: "evenodd",
      fill: "#889ccc"
    }
  }), _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlert, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/alert.663651dd.svg";
export { ForwardRef as ReactComponent };